import React, { useState, useEffect, useContext } from 'react';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import { ConfigContext } from '../context/GlobalContext';

const VoiceButton = ({ customers }) => {
    const { state ,dispatch } = useContext(ConfigContext);
  
  const [response, setResponse] = useState('');
  const [microphoneStatus, setMicrophoneStatus] = useState('');
  const { transcript, listening, resetTranscript, browserSupportsSpeechRecognition } = useSpeechRecognition();


  // Handle transcript (speech) and send reminder logic
  useEffect(() => {
    if (transcript) {
      handleTranscript(transcript);
    }
  }, [transcript]);

  const handleTranscript = (text) => {
    // Match "send reminder to [name]"
    const match = text.match(/send reminder to\s*(.*)/i);

    if (match) {      
      const name = match[1].trim().toLowerCase();
      if (!name) {
        setResponse('⚠️ You said "send reminder to" but no name was given.');
        return;
      }
    
      const customer = state.CUSTOMERS.find(c => c.customer.toLowerCase() === name);
      if (customer) {
        setResponse(`✅ Reminder sent to ${customer.name} (${customer.email})`);
      } else {
        setResponse(`❌ Customer "${name}" not found.`);
      }
    } else {
      setResponse('⚠️ Command not recognized.');
    }
  }    

  // Toggle speech recognition
  const toggleListening = () => {
    if (listening) {
      SpeechRecognition.stopListening();
    } else {
      resetTranscript();
      SpeechRecognition.startListening({ continuous: true, language: 'en-US' });
    }
  };

  if (!browserSupportsSpeechRecognition) {
    return <p>Your browser does not support speech recognition.</p>;
  }

  return (
    <div style={{ padding: 20 }}>
      <button onClick={toggleListening}>
        {listening ? '🛑 Stop Listening' : '🎤 Start Listening'}
      </button>
      <button onClick={resetTranscript} style={{ marginLeft: 10 }}>
        🔄 Reset
      </button>

      <p><strong>Listening:</strong> {listening ? 'Yes' : 'No'}</p>
      <p><strong>You said:</strong> {transcript || 'Say something...'}</p>
      <p><strong>Result:</strong> {response}</p>
    </div>
  );
};

export default VoiceButton;
